exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tour-bikes .bike{border:1px solid #f2f2f2;margin:0 0 50px;position:relative\n}\n.tour-bikes .bike__primary{background:#f2f2f2;display:grid;grid-gap:20px;grid-template-columns:1fr 2fr 1fr 2fr;padding:20px 35px 20px 20px\n}\n.tour-bikes .bike__primary .button{margin-bottom:0\n}\n.tour-bikes .bike input,.tour-bikes .bike p,.tour-bikes .bike select{margin:0\n}\n.tour-bikes .bike .remove-circle{right:4px;top:4px\n}", ""]);

// exports
